export default Object.freeze({
  Allow: 1,
  Deny: 2,
});
